import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["flash", "template", "message"];

  FLASH_LIMIT = 5; // Any more will cause older flash messages to be removed

  connect() {
    window.addEventListener("flash:create", ({ detail: { type, message } }) => {
      this.createFlash(type, message);
    });
  }

  flashTargetConnected(element) {
    if (this.flashTargets.length > this.FLASH_LIMIT) {
      const oldestFlash = this.flashTargets[this.FLASH_LIMIT];
      this.dismiss({ currentTarget: oldestFlash });
    }

    element.classList.add("fade-in");

    setTimeout(() => {
      this.dismiss({ currentTarget: element });
    }, 15000);
  }

  dismiss({ currentTarget }) {
    const flash = currentTarget.closest(".flash--wrapper");

    if (!flash) return;

    flash.style.setProperty("transform", "translateY(0px)");
    flash.style.setProperty("opacity", "1");
    flash.classList.replace("fade-in", "fade-out");

    setTimeout(() => {
      flash.remove();
    }, 150);
  }

  createFlash(type, message) {
    const flashClone = this.templateTarget.content.cloneNode(true);
    const messageElement = flashClone.querySelector(".flash--message");
    const flashWrapper = flashClone.querySelector(".flash--wrapper");

    flashWrapper.classList.add(`alert-${type}`);
    messageElement.innerHTML = message;

    this.element.prepend(flashClone);
  }
}
